import { z } from "zod";

export const x5PrintImageDimensionsSchema = z.object({
	width: z.number().optional(),
	height: z.number().optional(),
	length: z.number().optional(),
});

export const x5PrintImageSchema = z.object({
	id: z.string().optional(),
	tenantId: z.string().optional(),
	alias: z.string().optional(),
	imageId: z.string().optional(),
	thumbnailImageId: z.string().optional(),
	fileSize: z.number().optional(),
	fileName: z.string().optional(),
	dimensions: x5PrintImageDimensionsSchema.optional(),
});

export type X5PrintImage = z.infer<typeof x5PrintImageSchema>;
export type X5PrintImageDimensions = z.infer<typeof x5PrintImageDimensionsSchema>;
